<template lang="html">
  <canvas class="voltage-gauge"></canvas>
</template>

<script>
import { RadialGauge } from 'canvas-gauges'

export default {
  name: 'voltage-gauge',
  props: {
    value: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      chart: {},
      options: {
        width: 250,
        height: 250,
        units: 'V',
        minValue: 10,
        maxValue: 16,
        startAngle: 90,
        ticksAngle: 180,
        majorTicks: [
          '10', '13', '16'
        ],
        minorTicks: 3,
        strokeTicks: true,
        highlights: false,
        valueBox: false,
        colorPlate: '#fff',
        borderShadowWidth: 0,
        borders: false,
        needleType: 'arrow',
        needleWidth: 2,
        needleCircleSize: 7,
        needleCircleOuter: true,
        needleCircleInner: false
      }
    }
  },
  watch: {
    value: function (speed) {
      this.chart.value = speed
    }
  },
  mounted () {
    this.options.value = this.value
    this.options.title = this.title
    this.options.renderTo = this.$el
    this.chart = new RadialGauge(this.options).draw()
  },
  beforeDestroy () {
    this.chart.destroy()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Gauges/Voltage.vue